$(document).ready(function () {
    const $slider = $('.heroSlider');

    $slider.slick({
        infinite: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        dots: true,
        appendDots: $('.dotsWrap'),
        fade: true,
        speed: 3000,
        cssEase: 'linear'
    });

    const cleanUpVideo = ($slide) => {
        const video = $slide.find('video')[0];
        if (video) {
            video.pause();
            video.currentTime = 0;
        }
    };

    const handleVideoPlayback = ($currentSlide) => {
        const $video = $currentSlide.find('video');
        if ($video.length > 0) {
            const video = $video.get(0);

            const $source = $video.find('source');
            if (!$source.attr('src')) {
                $source.attr('src', $source.data('src'));
                video.load();
            }

            $video.attr('playsinline', '');
            $video.attr('webkit-playsinline', '');
            video.muted = true;
            video.play();

            $slider.slick('slickPause');

            $video.off('ended').on('ended', function () {
                cleanUpVideo($currentSlide);
                $slider.slick('slickNext');
                $slider.slick('slickPlay');
            });
        } else {
            $slider.slick('slickPlay');
        }
    };

    $slider.on('beforeChange', function (event, slick, currentSlide) {
        cleanUpVideo($(slick.$slides[currentSlide]));
    });

    $slider.on('afterChange', function (event, slick, currentSlide) {
        const $currentSlide = $(slick.$slides[currentSlide]);
        handleVideoPlayback($currentSlide);
    });

    const $firstSlide = $slider.find('.slick-slide').eq(0);
    handleVideoPlayback($firstSlide);
});
